import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { Typography } from 'antd';

import s from './styles.module.scss';

import type { FC } from 'react';

const { Text } = Typography;

interface DateCellProps {
  date?: string | Date;
}

const DateCell: FC<DateCellProps> = ({ date }) => {
  return (
    <Text className={s.date}>
      {DateFormatter({
        date,
        format: DateFormats['MM/dd/yyyy hh:mm:ss a'],
      })}
    </Text>
  );
};
export default DateCell;
